import DualloTagClient from "@/clients/duallo/DualloTagClient";

class TagService {
    async createTag(newTag) {
        return await DualloTagClient.createTag(newTag);
    }

    async getTagsByOrganizationId(organizationId) {
        return await DualloTagClient.getTagsByOrganizationId(organizationId);
    }

    async updateTag(modifiedTag) {
        return await DualloTagClient.updateTag(modifiedTag);
    }
}

export default new TagService();
